"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _reselect = require('reselect');
var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);





var _versionGuards = require('shared/services/versionGuards');
var _contact = require('shared/enum/contact');
var _relations = require('shared/selectors/user/relations');
var _common = require('./common');

 const orgHasFeature = (
  org,
  featureFlag,
) => !!org
  && _versionGuards.isOrgV1.call(void 0, org)
  && org.EnabledFeatures.includes(featureFlag); exports.orgHasFeature = orgHasFeature

 const makeSelectOrgHasFeature = (featureFlag) => _reselect.createSelector.call(void 0, 
  (s, ok) => _common.selectOrgByKey.call(void 0, ok, s),
  org => exports.orgHasFeature.call(void 0, org, featureFlag),
); exports.makeSelectOrgHasFeature = makeSelectOrgHasFeature

 const selectOrgHasPatientMessagingFeature =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.PATIENT_MESSAGING); exports.selectOrgHasPatientMessagingFeature = selectOrgHasPatientMessagingFeature

 const selectOrgHasAdvancedSearch =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.ADVANCED_SEARCH); exports.selectOrgHasAdvancedSearch = selectOrgHasAdvancedSearch

 const selectOrgHasForms =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.FORMS); exports.selectOrgHasForms = selectOrgHasForms

 const selectOrgHasConsent =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.CONSENT); exports.selectOrgHasConsent = selectOrgHasConsent

 const selectOrgHasKeywords =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.KEYWORDS); exports.selectOrgHasKeywords = selectOrgHasKeywords
 const selectOrgHasReports =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.REPORTS); exports.selectOrgHasReports = selectOrgHasReports

 const selectOrgHasBranding =
  exports.makeSelectOrgHasFeature.call(void 0, _features2.default.BRANDING); exports.selectOrgHasBranding = selectOrgHasBranding

const NO_PATIENT_MESSAGING_ORGS = []

 const selectPatientMessagingOrgs = _reselect.createSelector.call(void 0, 
  [
    _relations.selectMyActiveOrgsList,
    _common.selectOrgs,
    (_state, contactRelType) => contactRelType,
  ],
  (activeOrgs, orgsV1, contactRelType) => {
    if (contactRelType !== _contact.CONTACT_REL_TYPES.PATIENT) {
      return NO_PATIENT_MESSAGING_ORGS
    }
    return activeOrgs.filter(org =>
      exports.orgHasFeature.call(void 0, orgsV1[org.OrgKey] , _features2.default.PATIENT_MESSAGING),
    )
  },
); exports.selectPatientMessagingOrgs = selectPatientMessagingOrgs
